export type ToastKind = 'success' | 'error';

export function toastDuration(kind: ToastKind): number {
  return kind === 'success' ? 4000 : 7000;
}
